import { Directive, ElementRef, EventEmitter, NgModule, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appDomChange]'
})
export class DomChangeDirective implements OnDestroy, OnInit {

  private changes: MutationObserver;

  @Output('appDomChange') domChange = new EventEmitter();

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
    const element = this.elementRef.nativeElement;

    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) => {
        this.domChange.emit(mutation);
      });
    });

    this.changes.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  ngOnDestroy(): void {
      this.changes && this.changes.disconnect();
  }
}
@NgModule({
  declarations: [DomChangeDirective],
  exports: [DomChangeDirective],
})
export class DomChangeModule { }
